import { IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonPage, IonRow, IonSelect, IonSelectOption, IonText, IonTitle, IonToolbar, useIonRouter, useIonToast, useIonViewDidLeave, useIonViewWillEnter } from '@ionic/react';
import { checkmarkCircleOutline, chevronBackOutline, keyOutline, lockClosedOutline } from 'ionicons/icons';
import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../AppProvider';
import { Alert, AlertTitle } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const ForgotPasscode: React.FC = () => {
    const [disableSubmit, setDisableSubmit] = useState<boolean>(true);
    const [formSubmitted, setFormSubmitted] = useState<boolean>(false);

    //const [showToast] = useIonToast();
    const router = useIonRouter();
    const emailInput = useRef<any>();

    const { setShowLoader, SWFullHorizLogo, SWTextDarkLogo, showToast } = useAppContext();
        
    
    useIonViewWillEnter(() => {
         setShowLoader(false);
        document.body.classList.remove('dark');       
    });

    useIonViewDidLeave(() => {
        setFormSubmitted(false);
        //setDisableSubmit(true);
    });

    const validateForm = () => {
        setDisableSubmit(true);
        const email = emailInput.current.value;
        const disable = (email.length < 6 ||
                         email.includes('@') == false ||
                         email.includes('.') == false ||
                         (email.match(/@/g)).length != 1 ||
                         email.indexOf('@') > email.lastIndexOf('.'));
        setDisableSubmit(disable);
    };

    const requestPasscodeReset = async (e:any) => {
        setDisableSubmit(true);

        e.preventDefault();
        e.stopPropagation();
        
        const form = e.target; 
        const formData = new FormData(form);
        try {
            const apiURI = 'https://api.besolowise.com/members/authenticate/reset/';
            const response = await fetch(apiURI, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json(); 
                              
                if(obj.success) {
                    setFormSubmitted(true);
                } else {
                    setDisableSubmit(false);
                    showToast({
                        message: obj.message,
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                setDisableSubmit(false);
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 2000,
                    color: 'danger',
                    position: 'middle'
                });  
            }  
             
        } catch(error) {
            setDisableSubmit(false);
            showToast({
                message: 'Connection Error: ' + error + '. Try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        }  
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton routerLink='/login'><IonIcon icon={chevronBackOutline}></IonIcon> Back</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className='headerTextLogo' src={SWFullHorizLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>                   
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h1><IonIcon color={'secondary'} icon={keyOutline}></IonIcon> Forgot your passcode?<br /><span>Start the reset process here</span></h1>
                        </IonCol>
                    </IonRow>
                </IonGrid>

               <div className='ion-padding'>   
                    <Alert
                        severity="info"
                        icon={<InfoOutlinedIcon fontSize="inherit" />}
                        sx={{
                        borderRadius: 2,
                        mb: 2,
                        cursor: 'pointer'
                        }}
                    >                        
                        <AlertTitle>Instructions</AlertTitle>
                        <div className='ion-margin-top'>
                            Enter the email address you have registered with SoloWise, and you'll be sent a verification email with further instructions to reset your passcode.
                        </div>
                    </Alert>
                </div>
                <IonGrid fixed>
                    <IonRow class='ion-justify-content-center'>
                        <IonCol size='12' sizeMd='8' sizeLg='6' sizeXl='4'>
                            <IonCard>
                                <IonCardContent>
                                    {!formSubmitted
                                        ? (<form onSubmit={requestPasscodeReset}>
                                                <IonInput className='ion-margin-top' fill='outline' label='Email address' labelPlacement='stacked' name='resetEmail' onKeyUp={validateForm} ref={emailInput} type='email'></IonInput>
                                                <IonButton className='ion-margin-top ion-margin-bottom' color={disableSubmit ? 'primary' : 'secondary'} type='submit' expand='block' disabled={disableSubmit}>Submit Email</IonButton>
                                                <p className='ion-text-center'><Link to="/login">Cancel</Link></p>
                                           </form>)
                                        : (<>
                                            <h3 className='ion-text-center ion-margin-bottom'><IonText color={'success'}><strong><IonIcon className='ion-margin-bottom' icon={checkmarkCircleOutline} size='large'></IonIcon><br />OK! We just sent the verification email.</strong></IonText></h3>
                                            <p className='ion-text-center'>After you complete the passcode reset process, you can <Link to="/login">log-in</Link>.</p>
                                           </>)
                                    }
                                </IonCardContent>
                            </IonCard>  
                        </IonCol>
                    </IonRow>
                </IonGrid>    
            </IonContent>
        </IonPage>
    );
};

export default ForgotPasscode;